import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Alert,
  Button,
} from "@mui/material";

import { APP_API_V1_BASE } from "../../config/api";
export default function AcceptInvite() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (!token) {
      setError("Invalid invite link");
      setLoading(false);
      return;
    }

    const acceptInvite = async () => {
      try {
        const authToken = localStorage.getItem("authToken");

        const res = await axios.post(
          `${APP_API_V1_BASE}/invites/accept`,
          { token },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          },
        );

        setSuccess(res.data);
      } catch (err) {
        setError(err.response?.data?.error || "Failed to accept invitation");
      } finally {
        setLoading(false);
      }
    };

    acceptInvite();
  }, [token]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="#f9fafb"
    >
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          width: 400,
          textAlign: "center",
        }}
      >
        {loading && (
          <>
            <CircularProgress />
            <Typography mt={2}>Accepting invitation...</Typography>
          </>
        )}

        {error && (
          <>
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
            <Button variant="contained" onClick={() => navigate("/overview")}>
              Go to Dashboard
            </Button>
          </>
        )}

        {success && (
          <>
            <Alert severity="success" sx={{ mb: 2 }}>
              Invitation accepted!
            </Alert>

            <Typography variant="body2" mb={2}>
              Organization: {success.organization?.name}
            </Typography>

            <Button variant="contained" onClick={() => navigate("/overview")}>
              Continue
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
